<template>
  <div style="   white-space:normal; display: flex; align-items: center; gap: 10px">
    <div>{{ scope.row.productName }}</div>
    <img v-if="scope.row.optionalType == 1 && scope.row.propertyCode === '1001'" src="@/assets/selectProduct.png" alt="">
    <img v-if="scope.row.standardFlag == 1" src="@/assets/newImport.png" alt="">
    <img v-if="scope.row.isDiscount && !isPartner" src="@/assets/promotion-new.png" alt="">
    <img v-if="isControlled(scope.row)" src="@/assets/controlled-new.png" alt="">
    <img v-if="isNewProduct(scope.row)" src="@/assets/newproduct-new.png" alt="">
    <img v-if="scope.row.industryIsEnabled == false" src="@/assets/shelves-new.png" alt="">
    <img v-if="scope.row.quotation == 1" src="@/assets/fuwushang-new.png" alt="">
    <img v-if="scope.row.quotation == 2 && getStore('industryFlg') == 1" src="@/assets/fuwushang-new.png" alt="">
  </div>
</template>

<script>
import api from '../../api';
import {
  setStore, getStore, isPartnerM, isNotNull, removeStore, isControlled, isNewProduct, isOrNoCollection
} from '@/utils/mUtils';
export default {
  name: 'ProductNameFormation',
  props: {
    scope: {
      type: Object,
      default: () => ({})
    }
  },
  components: {},
  data() {
    return {
      isPartner: true
    };
  },
  mounted() {
    this.isPartner = isPartnerM();
    // console.log("au=",getStore('industryFlg'));
    // console.log(this.isPartner);
  },
  methods: {
    isPartnerM, isNotNull, removeStore, isControlled, isNewProduct, isOrNoCollection, getStore
  }
};
</script>

<style scoped>
img {
  height: 20px;
}
</style>
